import { Map } from 'immutable';

import {
  INIT_PUBLISHER,
  ERR_INIT_PUBLISHER,
  ERR_PUBLISH_PUBLISHER,
  DESTROY_PUBLISHER,
  UPDATE_PUBLISHER,
  STREAM_PROPERTY_CHANGED,
  UPDATE_PUBLISHER_AUDIO_LEVEL,
} from 'OPENTOK/action_types';
import Publisher, { PUBLISHER_STATUS_INIT } from 'OPENTOK/models/publisher';

const streamPropertyChanged = (state, action) => {
  const streamId = action.id;
  const payload = action.payload;
  const targetKey = state.findKey((publisher) => publisher.get('streamId') === streamId);

  return state.update(
    targetKey,
    (publisher) =>
      (publisher
        ? publisher.mergeDeep({ audioStatus: payload.hasAudio, videoStatus: payload.hasVideo })
        : publisher),
  );
};

const publishers = (state = new Map({}), action) => {
  switch (action.type) {
    case INIT_PUBLISHER:
      return state.set(
        action.id,
        new Publisher({
          id: action.id,
          status: PUBLISHER_STATUS_INIT,
          ...action.payload,
        }),
      );
    case UPDATE_PUBLISHER:
      return state.update(
        action.id,
        (publisher) => (publisher ? publisher.mergeDeep(action.payload) : publisher),
      );
    case STREAM_PROPERTY_CHANGED:
      return streamPropertyChanged(state, action);
    case UPDATE_PUBLISHER_AUDIO_LEVEL:
      return state.update(
        action.id,
        (publisher) =>
          (publisher ? publisher.updateAudioLevel(action.payload.audioLevel) : publisher),
      );
    case DESTROY_PUBLISHER:
    case ERR_INIT_PUBLISHER:
    case ERR_PUBLISH_PUBLISHER:
      return state.delete(action.id);
    default:
      return state;
  }
};

export default publishers;
